import { Routes } from '@angular/router';
import { AuthGuard } from 'guards/auth.guard';
import { CapabilitiesGuard } from 'guards/capabilities.guard';
import { MaintenanceGuard, MaintenanceOnlyGuard } from 'guards/maintenance.guard';

export const routes: Routes = [
	{
		path: 'login',
		canActivate: [MaintenanceGuard],
		loadComponent: () =>
			import('components/layouts/clear-layout/clear-layout.component').then(
				(m) => m.ClearLayoutComponent,
			),
		loadChildren: () => import('pages/auth/auth.routes').then((r) => r.AUTH_ROUTES),
	},

	{
		path: 'external',
		canActivate: [MaintenanceGuard],
		loadChildren: () => import('pages/external/external.routes').then((r) => r.EXTERNAL_ROUTES),
	},

	{
		path: 'maintenance',
		// Acesso direto bloqueado fora do modo manutenção #26205
		canActivate: [MaintenanceOnlyGuard],
		loadComponent: () =>
			import('components/layouts/clear-layout/clear-layout.component').then(
				(m) => m.ClearLayoutComponent,
			),
		children: [
			{
				path: '',
				loadComponent: () =>
					import('pages/errors/maintenance/maintenance.component').then(
						(p) => p.MaintenanceComponent,
					),
				data: { title: 'Em manutenção' },
			},
		],
	},

	{
		path: 'skrull-access',
		loadComponent: () =>
			import('components/layouts/clear-layout/clear-layout.component').then(
				(m) => m.ClearLayoutComponent,
			),
		canActivate: [MaintenanceGuard, CapabilitiesGuard, AuthGuard],
		data: { capabilityName: 'skrull/access' },
		children: [
			{
				path: '',
				loadComponent: () =>
					import('pages/auth/login-as/login-as.component').then((p) => p.LoginAsComponent),
			},
		],
	},

	{
		path: '',
		loadComponent: () =>
			import('components/layouts/app-layout/app-layout.component').then(
				(m) => m.AppLayoutComponent,
			),
		canActivate: [MaintenanceGuard, AuthGuard],
		children: [
			{
				path: '',
				redirectTo: 'task',
				pathMatch: 'full',
			},
			{
				path: 'change-password',
				loadComponent: () =>
					import('pages/auth/change-password/change-password.component').then(
						(p) => p.ChangePasswordComponent,
					),
				data: { title: 'Alterar senha' },
			},
			{
				path: 'task',
				canActivate: [CapabilitiesGuard],
				data: { capabilityName: 'task/home' },
				loadChildren: () => import('pages/task/task.routes').then((r) => r.TASK_ROUTES),
			},
			{
				path: 'workflow',
				canActivate: [CapabilitiesGuard],
				data: { capabilityName: 'workflow/initializer/button' },
				loadChildren: () =>
					import('pages/workflow-initializer/wrokflow-initializer.routes').then(
						(r) => r.WORKFLOW_INITIALIZER_ROUTES,
					),
			},
			{
				path: 'base',
				canActivate: [CapabilitiesGuard],
				data: { capabilityName: 'base/home' },
				loadChildren: () => import('pages/base/base.routes').then((r) => r.BASE_ROUTES),
			},
			{
				path: 'calendar',
				children: [{ path: '**', redirectTo: '/task' }],
				// Rota desabilitada #26205
				// canActivate: [CapabilitiesGuard],
				// data: { capabilityName: 'correspondent/calendar' },
				// loadChildren: () =>
				// 	import('pages/calendar/calendar-page.routes').then((r) => r.CALENDAR_ROUTES),
			},
			{
				path: 'reports',
				canActivate: [CapabilitiesGuard],
				data: { capabilityName: 'reports/dynamic/start' },
				loadChildren: () => import('pages/reports/reports.routes').then((r) => r.REPORTS_ROUTES),
			},
			{
				path: 'management',
				canActivate: [CapabilitiesGuard],
				data: { capabilityName: 'management/general' },
				loadChildren: () =>
					import('pages/management/management.routes').then((r) => r.MANAGEMENT_ROUTES),
			},
			{
				path: 'finances',
				canActivate: [CapabilitiesGuard],
				data: { capabilityName: 'finances' },
				loadChildren: () => import('pages/finances/finances.routes').then((r) => r.FINANCES_ROUTES),
			},
			{
				path: 'tools',
				children: [{ path: '**', redirectTo: '/task' }],
				// Rota desabilitada #26205
				// canActivate: [CapabilitiesGuard],
				// data: { capabilityName: 'tools' },
				// loadChildren: () => import('pages/tools/tools.routes').then((r) => r.TOOLS_ROUTES),
			},
			{
				path: 'ai-metrics',
				children: [{ path: '**', redirectTo: '/task' }],
				// Rota desabilitada #26205
				// canActivate: [CapabilitiesGuard],
				// data: { capabilityName: 'tools' },
				// loadChildren: () =>
				// 	import('pages/ai-metrics/ai-metrics.routes').then((r) => r.AI_METRICS_ROUTES),
			},
			{
				path: 'dashboard',
				children: [{ path: '**', redirectTo: '/task' }],
				// Rota desabilitada #26205
				// canActivate: [CapabilitiesGuard],
				// data: { capabilityName: 'dashboard/court' },
				// loadChildren: () =>
				// 	import('pages/dashboard/dashboard.routes').then((r) => r.DASHBOARD_ROUTES),
			},
			{
				path: 'settings',
				loadComponent: () =>
					import('pages/settings/settings.component').then((r) => r.SettingsComponent),
			},
			{
				path: '**',
				loadComponent: () =>
					import('pages/errors/not-found/not-found.component').then((r) => r.NotFoundComponent),
			},
		],
	},

	{
		path: '403',
		canActivate: [MaintenanceGuard, AuthGuard],
		loadComponent: () =>
			import('components/layouts/clear-layout/clear-layout.component').then(
				(m) => m.ClearLayoutComponent,
			),
		children: [
			{
				path: '',
				loadComponent: () =>
					import('pages/errors/forbidden/forbidden.component').then((p) => p.ForbiddenComponent),
				data: { title: 'Acesso negado' },
			},
		],
	},
];
